import EqualizerIcon from '@mui/icons-material/Equalizer';
import SubjectIcon from '@mui/icons-material/Subject';
import SettingsIcon from '@mui/icons-material/Settings';


export const DTPG_NAVIGATION_MENU = [
  {
    id: 1,
    name: "Manage",
    titleKey: "menu.dtpg.manage",
    icon: <SubjectIcon />,
    link: "/dtpg/manage",
    version: "1001"
  },
  {
    id: 37,
    name: "Settings",
    titleKey: "menu.dtpg.settings",
    icon: <SettingsIcon />,
    link: "/dtpg/settings",
    version: "1001"
  },
  {
    id: 166,
    name: "Configure",
    titleKey: "menu.dtpg.configure",
    icon: <EqualizerIcon />,
    link: "/dtpg/configure",
    version: "1001"
  },
  {
    id: 208,
    name: "Display",
    titleKey: "menu.dtpg.display",
    icon: <SubjectIcon />,
    link: "/dtpg/display"
  },
  {
    id: 216,
    name: "Metering",
    titleKey: "menu.dtpg.metering",
    icon: <SettingsIcon />,
    link: "/dtpg/metering"
  },
  {
    id: 242,
    name: "License Information",
    titleKey: "menu.dtpg.license_info",
    layout: "settings-list",
    icon: <SubjectIcon />,
    link: "/dtpg/licenseInformation"
  },
];
